export default __webpack_public_path__ + "static/media/O-057.9149d81f.png";